import React, { useState, useEffect } from 'react';
import { Heatmap } from '@ant-design/plots';

const HeatMapChart = ({ data, color, xField, yField, xAxisLabel, yAxisLabel, type }) => {

  const [chartColor, setChartColor] = useState(["#16A085", "#2193AE", "#2159AE", "#4945A8", "#AE43B2", "#34495e", "#f9c232", '#2b8a84', "#239b56", "#34495e"]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    // if (color == "research") {
    // setChartColor(["#16A085", "#2193AE", "#2159AE", "#4945A8", "#AE43B2", "#34495e", "#f9c232", '#2b8a84', "#239b56", "#34495e"]);
    setChartColor(["#A4E0F7", "#71AECE", "#3E7CA5", "#0b4a7c"]);
    // }
  };

  const config = {
    data,
    // color: chartColor,
    scale: {
      color: {
        range: chartColor
      },
    },
    xField: "type",
    yField: "group",
    colorField: 'value',
    mark: 'cell',
    style: { inset: 0.5 },
    label: {
      text: 'value',
      position: 'inside',
    },
    axis: {
      x: {
        title: xAxisLabel,
        style: {
          titleFill: 'black'
        },
        labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
      },
      y: {
        title: yAxisLabel,
        style: {
          titleFill: 'black'
        }
      }
    },
    tooltip: {
      title: 'text',
      field: 'value',
      pointerEvents: 'none',
      items: [
        {
          channel: "x",
          name: 'Dissemonation Type',
        },
        {
          channel: "y",
          name: 'Partner Type:',
        },
        {
          channel: "color",
          name: 'Number',
        },
      ],
    }
  };

  return <Heatmap {...config} />
};

export default HeatMapChart;